// @flow

import React from 'react';
import { MdPlaylistAdd } from 'react-icons/md';
import './WriteSeriesConfigure.scss';

type Props = {
  series: ?{ id: string, name: string },
  onOpenModal: () => any,
};

const WriteSeriesConfigure = ({ series, onOpenModal }: Props) => {
  return (
    <div className="WriteSeriesConfigure">
      {series ? (
        <div className="series-box edit">
          <div className="name">{series.name}</div>
          <div className="separator" />
          <div className="change" onClick={onOpenModal}>
            변경
          </div>
        </div>
      ) : (
        <button className="series-box create" onClick={onOpenModal}>
          <MdPlaylistAdd />
          <div className="series-text">시리즈에 추가하기</div>
        </button>
      )}
    </div>
  );
};

export default WriteSeriesConfigure;



// WEBPACK FOOTER //
// ./src/components/write/WriteSeriesConfigure/WriteSeriesConfigure.js